export default {
  go_to_questionnaire: "Go to questionnaire",
  studea_manager: {
    confirm_duplication: "Are you sure you want to duplicate this data?",
    data_duplicated_success: "Data duplicated successfully",
    delete_session_confirmation: "Are you sure you want to delete this period?",
    delete_referential_confirmation: "Are you sure you want to delete this reference documentation?",
    navigation: {
      general: "General",
      modules: "Modules",
      pilotage: "Steering",
    },
    triadUser: {
      title: "secondary user",
    },
    moderation: {
      title: ({ plural }) => plural(["Flag", "Flags"]),
      censor: "Block",
      restore: "Cancel block",
      show: "View",
      show_censor: "View blocked messages",
      show_message: "View messages for moderation",
      file: "File",
      modal_title: "Conversation",
      alert_title: "Block a message",
      alert_sub_title: "Would you like to block or cancel the flagging on this message?",
      censor_success: "Message blocked successfully!",
    },
    home: {
      title: ({ plural }) => plural(["Configuration of: ", "Configuration of: "]),
      page_title: "Configuration",
    },
    trainingSkillCategory: {
      title: ({ plural }) => plural(["Skill block", "Skill blocks"]),
      block: ({ plural }) => plural(["Block", "Blocks"]),
    },
    trainingSkillCriticalLearning: {
      title: ({ plural }) => plural(["Critical learning", "Critical learnings"]),
      level_column: "Level",
      content_column: "Critical learning",
      level: ({ named }) => `Level ${named("n")}`,
      empty:
        "No critical learning defined for this skill. Use AI to generate them or edit the skill to add them manually.",
      empty_action: "Edit the skill",
      collapse: "Hide critical learnings",
      expand: "Show critical learnings",
      update_success: "Critical learning updated successfully",
      update_error: "Error while updating the critical learning",
    },
    questionnaire: {
      title: ({ plural }) => plural(["Questionnaire", "Questionnaires"]),
      list: {
        title: "Advanced configuration",
      },
      questionnaire_already_signed: "Please note, the questionnaire has already been signed!",
      duplicate_year: {
        title: "Duplicate to next year",
        confirm: "Do you want to duplicate all questionnaires from this year to the next year?",
        success: "The questionnaires have been duplicated to the next year",
      },
      start_date: ({ named }) => `Access date ${named("profile")} - for`,
      end_date: "to",

      finish: {
        title: "Finish configuration",
      },
      empty_title: "To get started, please add a title, a question or a response cluster!",
      add_question: "Add a question",
      add_title: "Add a title",
      add_question_cluster: "Add a cluster of questions",
      required: "Mandatory",
      question_settings: "Question settings",
      question_access: "Access settings",
      cluster_settings: "Cluster settings",
      remove_question: "Delete question",
      remove_cluster: "Delete cluster",
      remove_title: "Delete title",
      duplicate_cluster: "Duplicate cluster",
      duplicate_question: "Duplicate question",
      tip: "Tooltip",
      display_mode: "Response cluster",
      save: "Save",
      save_success: "Questionnaire saved successfully!",
      save_error: "Error when saving!",
      missing_error:
        "Warning, some access rights, question titles, question types or answer columns in questionnaire grids are missing!",
      informations: "Information",
      deadlines_reminders: "Due dates & reminders",
      advanced_parameter: "Advanced settings",
      company_visit: "InseeCompany visit",
      settings: "Settings",
      summary: "Summary",
      add_column: "Add a column",
      add_row: "Add row",
      row_settings: "Who needs to complete this?",
      skill_settings: "Manage related skills",
      access_missing: "Access permissions missing for this question",
      title_missing: "Please enter a title for this question",
      value_title_missing: "Vous devez renseigner un titre pour cette valeur",
      duplicate_row: "Duplicate line",
      remove_row: "Delete line",
      remove_column: "Delete column",
      empty_line: "Untitled line",
      add_skill: "Add this skill",
      skill_category_name: "Category",
      skill_name: "Surname",
      coefficient: "Coefficient",
      mission: "Mission",
      activity: "Activity",
      mission_block_title: "Contract missions",
      mission_preview_summary_example: "3 in progress · 1 completed · 1 archived",
      mission_summary_counts: "{inProgress} in progress · {completed} completed · {archived} archived",
      mission_example_name: "Development of a new internal application",
      mission_progress_label: "Progress",
      mission_objectives_label: "Objectives for this period",
      mission_objectives_placeholder: "Describe the objectives to achieve for this period",
      item_filter_display_label: "Show",
      item_filter_completion_label: "Completion",
      item_filter_chronology_label: "Chronology",
      mission_filter_all: "All",
      mission_filter_in_progress: "In progress",
      mission_filter_completed: "Completed",
      mission_filter_archived: "Archived",
      item_sort_label: "Sort",
      mission_sort_start_date: "Start date",
      mission_sort_end_date: "End date",
      mission_comment_label: "Comment",
      mission_comment_placeholder: "Add a comment (optional)",
      mission_completed_badge: "Completed",
      mission_archived_badge: "Archived",
      mission_filter_results_count: "{count} mission(s) displayed",
      mission_archive_action: "Archive",
      mission_archive_modal_title: "Archive a mission",
      mission_archive_warning:
        'Archiving hides the mission from the active list. It remains available via the "Archived" filter. This action is reversible.',
      mission_archive_reason_label: "Reason for archiving",
      mission_archive_reason_placeholder:
        "Explain why this mission is being archived (scope change, redundancy, contract reorientation...)",
      mission_archive_submit: "Archive the mission",
      mission_archive_success: "The mission has been successfully archived",
      mission_unarchive_action: "Unarchive",
      mission_unarchive_confirm_title: "Unarchive this mission?",
      mission_unarchive_confirm_text: "The mission will become visible again in the in-progress missions list.",
      mission_unarchive_success: "The mission has been successfully unarchived",
      mission_edit_action: "Edit",
      mission_edit_modal_title: "Edit a mission",
      mission_edit_confirm_title: "Confirm the change?",
      mission_edit_confirm_subtitle:
        "This change will be applied to the contract mission and visible in the overall summary.",
      mission_edit_success: "The mission has been successfully updated",
      mission_add_action: "Add a mission",
      mission_add_label: "Add",
      mission_add_modal_title: "Add a mission",
      mission_add_success: "The mission has been successfully created",
      mission_history_action: "View objectives history",
      mission_history_modal_title: "Objectives history",
      mission_history_empty: "No objective has been defined yet for this mission.",
      mission_history_error: "An error occurred while loading the history.",
      mission_history_defined_by: "Defined by {name} ({profile}) · {date}",
      history_profile_apprentice: "Apprentice",
      history_profile_tutor: "Tutor",
      history_profile_apprenticeMaster: "Apprentice master",
      history_profile_studeaManager: "Manager",
      activity_block_title: "Contract activities",
      activity_preview_summary_example: "2 in progress · 1 completed · 1 archived",
      activity_example_name: "Writing an analysis report",
      activity_sort_start_date: "Start date",
      activity_sort_end_date: "End date",
      activity_filter_results_count: "{count} activity(ies) displayed",
      activity_add_action: "Add an activity",
      activity_filter_all: "All",
      activity_filter_ongoing: "In progress",
      activity_filter_to_complete: "To complete",
      activity_filter_completed: "Complete",
      activity_filter_certified: "Certified",
      activity_filter_archived: "Archived",
      activity_to_certify_badge_label: "To certify",
      activity_to_certify_alert: "You have {count} activity(ies) to certify. Display completed activities.",
      activity_filter_finished: "Finished",
      activity_temporal_ongoing: "In progress",
      activity_temporal_finished: "Completed",
      activity_workflow_validated: "Validated",
      activity_workflow_certified: "Certified",
      activity_workflow_cancelled: "Cancelled",
      activity_step_creation: "Creation",
      activity_step_description: "Description",
      activity_step_analysis: "Analysis",
      activity_step_skills: "Skills",
      activity_step_validation: "Validation",
      activity_step_badge: "Step {number} - {label}",
      activity_stepper_label: "Activity progress",
      activity_step_state_done: "Step {number} of {total}: {label}, completed",
      activity_step_state_current: "Step {number} of {total}: {label}, in progress",
      activity_step_state_todo: "Step {number} of {total}: {label}, upcoming",
      activity_level_of_achievement: "{percent}% complete",
      activity_level_of_achievement_aria: "Activity completion: {percent}%",
      activity_edit_action: "Edit",
      activity_certify_action: "Certify",
      activity_view_action: "View",
      activity_end_date_action: "Set the end date",
      activity_archive_action: "Archive",
      activity_archive_modal_title: "Archive the activity",
      activity_archive_warning:
        "The archived activity will no longer be visible to tutors. It remains accessible to you.",
      activity_archive_submit: "Archive",
      activity_archive_success: "Activity archived",
      activity_unarchive_action: "Unarchive",
      activity_unarchive_confirm_title: "Unarchive this activity?",
      activity_unarchive_confirm_text:
        "The activity will return to draft status and become visible again in the in-progress activities list.",
      activity_unarchive_success: "The activity has been successfully unarchived",
      activity_archive_not_draft: "This activity can no longer be archived: it has already been signed.",
      activity_end_date_modal_title: "Set the end date",
      activity_end_date_info:
        "This date simply indicates that the activity is over in time. It does not open certification and does not lock the activity's content.",
      activity_end_date_label: "End date",
      activity_end_date_success: "End date saved",
      activity_edit_modal_title: "Edit an activity",
      activity_view_modal_title: "View an activity",
      activity_add_modal_title: "Add an activity",
      activity_history_action: "Tracking history",
      activity_history_modal_title: "Tracking history",
      activity_history_empty: "No update has been entered yet for this activity.",
      activity_history_error: "An error occurred while loading the history.",
      activity_history_defined_by: "Defined by {name} ({profile}) · {date}",
      activity_comment_label: "Progress tracking for this period",
      activity_comment_placeholder: "Describe what you actually accomplished on this activity during this period.",
      activity_commentaire_missing: "No tracking provided",
      activity_linked_mission: "Mission: {name}",
      activity_no_mission_linked: "No mission linked",
      activity_description_missing: "Description not provided",
      activity_skills_count: "{count} skill(s) used",
      activity_summary_counts:
        "{ongoing} in progress · {finished} finished · {toComplete} to complete · {completed} complete · {archived} archived",
      activity_summary_counts_without_archived:
        "{ongoing} in progress · {finished} finished · {toComplete} to complete · {completed} complete",
      activity_signature_summary_title: "Summary before validation",
      activity_signature_field_name: "Title",
      activity_signature_field_type: "Type",
      activity_signature_field_missions: "Mission(s)",
      activity_signature_field_skills: "Skills used",
      activity_signature_missions_more: ({ named }) => `${named("name")} +${named("count")}`,
      activity_signature_warning:
        "By validating, you lock the content of this activity (description, analysis, skills). It will be sent to your tutor, who will be able to assess the skills used and add a comment. This action cannot be reversed by you.",
      activity_signature_sign_button: "Validate",
      activity_signature_confirm_button: "Save and validate",
      activity_signature_confirm_modal_title: "Confirm validation",
      activity_signature_incomplete_hint: "The first four tabs must be complete before this activity can be validated.",
      activity_signature_locked_banner: ({ named }) =>
        `This activity was signed by ${named("name")} on ${named("date")}. Its content (description, analysis, skills) is locked.`,
      activity_signature_evaluation_title: "Assessment of the skills used",
      activity_signature_evaluation_optional_badge: "Optional",
      activity_signature_evaluation_subtitle:
        "You can assess all, some, or none of the skills declared by the apprentice.",
      activity_signature_certify_button: "Certify",
      activity_signature_certify_confirm_title: "Confirm certification",
      activity_signature_not_evaluated: "Not assessed",
      activity_signature_level_0: "Not implemented",
      activity_signature_level_1: "Initiated",
      activity_signature_level_2: "Operational",
      activity_signature_level_3: "Proficient",
      activity_signature_level_4: "Expert",
      activity_signature_certifier_comment_label: "Tutor's comment (optional)",
      activity_signature_certifier_comment_hint:
        "This comment will be visible to the apprentice and the rest of the triad.",
      activity_signature_certify_warning:
        "Certification is final. The activity will move to the “Certified” status and can no longer be edited by the apprentice. Assessments left blank remain “Not assessed”.",
      activity_signature_recap_validated_by: ({ named }) => `Signed by ${named("name")} on ${named("date")}`,
      activity_signature_recap_certified_by: ({ named }) => `Certified by ${named("name")} on ${named("date")}`,
      activity_signature_info_awaiting_signature: "Awaiting the apprentice's signature.",
      activity_signature_info_awaiting_certification: "Awaiting assessment and certification.",
      activity_signature_info_cancelled: "This activity has been archived.",
      activity_signature_info_default: "No action is available on this tab at the moment.",
      empty_column: "Column title",
      remove_field_skill: "Delete linked skill",
      field_skill_used: "This skill is already linked to this question",
      remove_field_skill_sub: "Are you sure you want to remove the link between this skill and the question?",
      untitled_column: "Untitled column",
      remove_row_warning: "Are you sure you want to delete this line?",
      remove_column_warning: "Are you sure you want to delete this column?",
      untitled_questionnaire: "Untitled form",
      placeholder_description: "Add your description",
      access_profil: "Profiles matching the question",
      field_skill: "Skills relating to the question",
      search_skill: "Search for a skill",
      opened_question_access: "Access to open questions",
      opened_questions: "Open questions",
      opened_questions_type: "Type of open questions",
      grid_title: "Cluster title",
      comments_enabled: "Comments enabled",
      comments_label: "Comment title",
      comments_type: "Type of comment fields",
      one_line: "Short response",
      multi_line: "Text area",
      maximal_mark: "Maximum grade",
      mark_scale: "Mark scale",
      display_mark: "Use notes",
      display_radar: "Display radar",
      question_title: "Question title",
      infobulle_content: "Popup content",
      question_comment: "Comments",
      field_type_choose: "Choose a type",
      short_answer: "Short response",
      long_answer: "Long response",
      textarea: "Text area",
      number: "Number",
      dropdown_list: "Dropdown list",
      unique_choice: "Single answer",
      multiple_choices: "Multiple choice",
      file: "File",
      date: "Date",
      question: ({ plural }) => plural(["question", "questions"]),
      date_time: "Date and time",
      remove_question_warning: "Are you sure you want to delete this question?",
      option: "Option",
      untitled_cluster: "Untitled cluster",
      untitled_title: "Title",
      title_label: "Title",
      remove_cluster_warning: "Are you sure you want to delete this cluster?",
      value: "Value",
      choose_option: "Choose an option",
      questionnaire_settings: "Questionnaire settings",
      confirm: "Confirm",
      cancel: "Cancel",
      rights: "Rights",
      notes_summary: "Notes and summary",
      option_placeholder: "Option",
      value_placeholder: "Note",
      comment_placeholder: "Add a comment",
      option_settings: "Options configuration",
      columns: "Columns",
      active: "Active",
      inactive: "Inactive",
      unable: {
        confirmation: "Are you sure you want to enable this questionnaire?",
        success: "Questionnaire successfully enabled!",
      },
      disable: {
        confirmation: "Are you sure you want to disable this questionnaire?",
        success: "Questionnaire successfully disabled!",
      },
      global_export_visibility: "Visible on the global export of the booklet",
    },
    category: {
      title: ({ plural }) => plural(["Category", "Categories"]),
      add: "Add a category",
      delete_with_links: {
        title: "Delete the linked category",
        sub_title:
          "This category is linked to questionnaires. You must delete these questionnaires before you can delete the category. Are you sure you want to continue ?",
        success: "Linked category successfully deleted !",
      },
    },
    mission: {
      title: ({ plural }) => plural(["Mission", "Missions"]),
    },
    group: {
      title: ({ plural }) => plural(["Group", "Groups"]),
    },
    training: {
      title: ({ plural }) => plural(["Training", "Trainings"]),
      go_to_list: "Go to the training list",
    },
    webLink: {
      title: ({ plural }) => plural(["Useful link", "Useful links"]),
    },
    trainingCourse: {
      title: ({ plural }) => plural(["Year group", "Year groups"]),
    },
    skill: {
      title: ({ plural }) => plural(["Skill", "Skills"]),
      list: {
        title: "Configuration of skills",
        empty: "There are no skills associated with this training course yet. Please create a new category to begin",
        empty_only: "No skills entered",
      },
      actions: {
        add: "Add a skill",
        module_actions: "Configuration",
        skill_actions: "Manage skills",
        session_actions: "Manage periods",
        import_export_actions: "Import/Export",
        reminder_actions: "Reminders",
        active_justificative: "Enable evidence for all competencies",
        active_justificative_title: "Enable evidence",
        active_justificative_activate_success: "Skill proofs successfully enabled!",
        active_justificative_unactivate_success: "Skill proofs successfully disabled!",
      },
      name: "Surname",
      level: "Level required",
      default: {
        not_acquired: "Not acquired",
        acquired: "Acquired",
        expert: "Expert",
        being_acquired: "In process of being acquired",
        insufficient_mastery: "Insufficient understanding",
        partial_mastery: "Partial understanding",
        average_mastery: "Average understanding",
        good_mastery: "Good understanding",
        excellent_mastery: "Excellent understanding",
      },
    },
    skill_configuration: {
      title: "Module configuration",
      success: "Configuration updated successfully!",
      use_admin: "Use the admin configuration?",
      warning: "Please note! Please complete the skills module configuration to enter reference documentation",
    },
    skill_referential: {
      title: "Skills reference documentation management",
      success: "Reference documentation updated successfully!",
      warning: "Please note! Please complete the skills module configuration to enter reference documentation",
      empty_add: "There is currently no reference documentation. Please click on ‘+’ to add some",
    },
    skill_generate: {
      title: "Generate a questionnaire based on skills",
      success: "Questionnaire generated successfully!",
    },
    skill_remove: {
      title: "Delete reference documentation (without questionnaires)",
      sub_title: "Are you sure you want to delete this reference documentation?",
      success: "Reference documentation deleted successfully!",
    },
    skill_import: {
      title: "Import your skills",
      success: "Skills imported successfully!",
    },
    skill_import_france_competence: {
      title: "Import France Skills reference documentation",
      confirm: "Are you sure you want to upload the France Skills reference documentation to this training course?",
      success: "Reference documentation imported successfully!",
    },
    skill_export: {
      title: "Export skills",
      success: "Skills exported successfully!",
    },
    skill_export_taught: {
      title: "Export subjects",
      success: "Subjects exported successfully!",
    },
    skillSession: {
      gestion: "Skills periods management",
      list: {
        title: "Configuration of periods",
        empty: "There are currently no periods. Please click on ‘+’ to add one",
      },
      title: ({ plural }) => plural(["Period", "Periods"]),
    },
    skillReferential: {
      title: ({ plural }) => plural(["Reference material", "Reference documentation"]),
      use: "Use reference documentation",
      empty: "There is no reference material linked to this period yet, please click on the + to link one",
    },
    skillCategory: {
      title: ({ plural }) => plural(["Category", "Categories"]),
    },
    skin: {
      title: ({ plural }) => plural(["Layout", "Layouts"]),
      list: {
        title: "Layout",
      },
    },
    termination_prevention: {
      title: "Termination monitoring and prevention",
    },
    gradebook: {
      title: ({ plural }) => plural(["Gradebook", "Gradebooks"]),
      global_config: "Header and footer",
      session_config: "Period configuration",
      exam_type: "List of examination types",
      start_date: "Opening date: ",
      end_date: "Closing date: ",
      empty_session: "No period exists at the moment, please add one.",
      empty_subject: "No subject is listed for this period. Please add one.",
      empty_exam:
        "No examination is listed for this subject. Please select one in the subject configuration by clicking here.",
      delete_session: {
        confirmation: "Are you sure you want to delete this period?",
        success: "Period successfully deleted!",
      },
      delete_subject: {
        confirmation: "Are you sure you want to remove this subject from the session?",
        success: "Subject successfully removed!",
      },
      delete_exam: {
        confirmation: "Are you sure you want to delete this exam?",
        success: "Exam successfully passed!",
      },
      scale: "Scale",
      set_exam_and_coef: "Enter the type of examination and the weighting for this subject",
    },
    exam: {
      title: ({ plural }) => plural(["Examination", "Examinations"]),
      type_title: "Type of examination",
    },
    triad: {
      title: ({ plural }) => plural(["Three-party group", "Three-party groups"]),
      list: {
        name: "Surname",
        apprentice_name: "Apprentice name",
        tutor_name: "Name of the teaching tutor",
        map_name: "Name of the company mentor",
        gestionnary_name: "Administrator name",
      },
      registration: {
        contract_link_title: ({ named }) => "View the contract" + (named("code") ? ": " + named("code") : ""),
        link_title: ({ named }) => "View the registration record" + (named("code") ? " : " + named("code") : ""),
        reference: ({ named }) => "Linked registration" + (named("code") ? " : " + named("code") : ""),
      },
      tutor: {
        title: ({ plural }) => plural(["Teaching tutor", "Teaching tutors"]),
      },
      map: {
        title: ({ plural }) => plural(["InseeCompany mentor", "InseeCompany mentors"]),
      },
      questionnaire_triad_already_signed:
        "Note that the signatures of \nquestionnaires are attached \nto this three-party group.",
      usurp: {
        title: "Log in as",
      },
      login: {
        title: "Manage username notifications",
      },
      delete_all: {
        tutor: "Delete all teaching tutors",
        map: "Delete all company mentors",
      },
      delete: {
        tutor: "Delete this teaching tutor",
        map: "Delete this company mentor",
        legal_responsible: "Delete this legal guardian",
      },
      delete_member: {
        title: "Member of three-party group",
      },
      delete_all_tutor: {
        title: "all teaching tutors",
      },
      delete_all_map: {
        title: "all company mentors",
      },
      edit: {
        legal_responsible: "Edit legal guardian",
        tutor: "Amend teaching tutor",
      },
      contract: {
        title: "Contract management",
      },
      complete: {
        title: "Add a member to the three-party group",
      },
      actions: {
        title: "Actions",
      },
      add_test: "test three-party group",
      add_test_success: "Test three-party group added successfully!",
      send_user_infos: "Manage username notifications",
      send_welcome_email: "Send welcome e-mail with log-in details",
      send_welcome_email_success: "Welcome e-mail(s) sent successfully!",
      reset_password: "Reset password and resend log-in details",
      reset_password_success: "Password reset e-mail(s) sent successfully!",
      activate_livret: "Activate handbook",
      deactivate_livret: "Deactivate handbook",
      livret_active_badge: "Handbook active",
      livret_inactive_badge: "Handbook not activated",
      send_user_infos_message: "Tick users and click on the type of e-mail you wish to send to them",
      add_secondary_user: "Add a secondary user to this three party group",
      add_secondary_user_success: "Secondary user added successfully",
      remove_secondary_user: "Secondary user deleted successfully",
    },
    studeaUser: {
      title: ({ plural }) => plural(["User", "Users"]),
    },
    user: {
      title: ({ plural }) => plural(["User", "Users"]),
    },
    crew: {
      title: ({ plural }) => plural(["Group", "Groups"]),
      cannot_remove: "You cannot delete a group containing three-party groups",
    },
    contract: {
      title: ({ plural }) => plural(["Contract", "Contracts"]),
      empty: "This three-party group does not have any contracts",
      number: "Contract no.",
      dates: "Contract dates",
      company: "InseeCompany",
      duration: "Duration",
      address: "Address",
      map: "InseeCompany tutor",
      manager: "Manager",
      contrat_type: "Type of contract",
      rupture_date: "Date of termination",
      contract_rupture_date: "Contract terminated on: ",
      dropped_out: "Dropped out on: ",
      rupture_reason: "Reason for termination",
      rupture_reason_text: "Comment",
      months: "month",
      also_tutor: "You are a tutor for this three-party group",
      incident_sheet: "An incident sheet is pending for this three-party group",
      no_current_access: "You no longer have access to this triad: a more recent contract has taken over",
    },
    template: {
      title: ({ plural }) => plural(["Template", "Templates"]),
    },
    lesson: {
      title: ({ plural }) => plural(["Lessons", "Lessons"]),
    },
    skillType: {
      title: ({ plural }) => plural(["Type of skill", "Types of skills", "Type of skills"]),
    },
    subject: {
      title: ({ plural }) => plural(["Subject", "Subjects"]),
      former: {
        add: "Add a trainer",
        add_new: "Add a trainer who is not on the list",
        is_former: "This user is already a trainer.",
        is_studea_manager:
          "This user is responsible for the booklet. Assigning them a new role could change these rights.",
        is_admin: "This user is an administrator; a trainer profile will be added to their account.",
        empty: "No users found. Please enter an email address, surname and first name to create a new trainer.",
        add_success: "Trainer successfully added",
      },
    },
    unit: {
      title: ({ plural }) => plural(["Unit", "Units"]),
    },
    planning: {
      title: ({ plural }) => plural(["Event", "Events"]),
      removeSelected: {
        title: "Delete selected events",
        sub_title: "Are you sure you want to delete these events?",
        sucess: "Events deleted successfully!",
      },
      end_of_recurrence: "End of recurrence:",
    },
    trainingCourseModuleTriad: {
      title: ({ plural }) => plural(["Module", "Modules"]),
    },
    absence: {
      title: ({ plural }) => plural(["Absence", "Absences"]),
      list: {
        title: "Attendance",
      },
      config: {
        title: "Configuration",
        success: "Configuration edited successfully!",
      },
      export: {
        full_list: "Full list of absences",
        apprentice_list: "List of absences by ",
        excel: "(excel)",
        pdf: "(pdf)",
        state: "Absences status (schedule)",
      },
      attestation: {
        title: "Publication of attendance certificate",
      },
    },
    module: {
      title: ({ plural }) => plural(["Module", "Modules"]),
      active: {
        success: "Module activated successfully!",
      },
      unactive: {
        success: "Module deactivated successfully!",
      },
    },
    registration: {
      title: ({ plural }) => plural(["Registration", "Registrations"]),
      list: {
        title: "Registrations",
      },
      go_to: "Go to registrations",
    },
    matching: {
      go_to: "Go to matching",
    },
    notepad: {
      title: ({ plural }) => plural(["Notepad", "Notepads"]),
    },
    note: {
      title: ({ plural }) => plural(["Note", "Notes"]),
    },
    document: {
      title: ({ plural }) => plural(["Document", "Documents"]),
      pedagogic_documents: "Teaching documentation",
      general_documents: "General documents",
      shared_documents: "Shared documents",
      shared_document_add: "Add a shared document",
      shared_document_edit: "Edit a shared document",
      shared_document_list: "Shared documents",
      shared_document_info: "This document has been shared. To edit it, please \n go to the list of shared documents",
      trainingCourse_documents: "Promotion documents",
      error_file_or_link: "Please add a file or enter a link",
      link: "link",
    },
    "document/shared": {
      title: ({ plural }) => plural(["Shared document", "Shared documents"]),
    },
    incident_sheet: {
      title: ({ plural }) => plural(["Incident sheet", "Incident sheets"]),
      list: "Incident sheets",
      add_comment: "Add a comment",
      close: "Close",
      close_confirmation: "Are you sure you want to close this incident sheet?",
      open: "Open",
      open_confirmation: "Are you sure you want to reopen this incident sheet?",
      delete: "Delete",
      delete_confirmation: "Are you sure you want to delete this incident sheet?",
      in_progress: "In progress",
      closed: "Closed",
      search: "Search for an incident sheet",
      see_sheet: "See the incident sheet",
      see_questionnaire: "View the questionnaire",
      comment: "Comments",
      status: "Status",
      no_status: "No status",
    },
    currently: "current",
    documentExchange: {
      list: {
        title: "Document exchange",
      },
    },
    messaging: {
      list: {
        title: "Inbox",
      },
    },
    dashboard: {
      list: {
        title: "Dashboard",
      },
      please_use_filter_to_see_data: "Please use the filters to view the data.",
      signature_cancel_confirmation: "Are you sure you want to cancel the signature?",
      filter: "Filter",
      delete_filters: "Remove filters",
      questionnaire: {
        unlocked_confirmation: "Would you like to unlock this questionnaire?",
        locked_confirmation: "Would you like to lock this questionnaire?",
        unlocked_all_confirmation: "Would you like to unlock all the questionnaires in this column?",
        unlock_all_questionnaires: "Unlock all questionnaires in this column",
        unlock_questionnaire: "Unlock this questionnaire",
        opening_date_on: "Opening date on",
        lock_questionnaire: "Lock this questionnaire",
        cancel_signature: "Cancel this signature",
        send_email_reminder: "E-mail reminder",
        send_email_reminder_confirmation: "Are you sure you want to send an e-mail reminder?",
        send_email_reminder_success: "E-mail sent successfully",
        send_email_reminder_no_mail: "No reminder sent: conditions are not yet met (not all respondents have signed).",
        success_all_unlock: "Questionnaires unlocked successfully !",
        success_unlock: "Questionnaire unlocked successfully!",
        success_lock: "Questionnaire locked successfully!",
        success_cancel_signature: "Signature cancelled successfully!",
        delete_category_confirmation: "Please note that the questionnaires in this category will be deleted.",
        to_much_data: "Too many items selected, please refine your search",
        table_lock: "Lock the questionnaires",
        table_unlock: "Don’t lock questionnaires",
      },
      mail_relance: {
        title: "Email reminder",
        subtitle: "Reminders will not be sent to locked questionnaires (closed padlock)",
      },
      email_reminder: "E-mail reminder",
      export: {
        title: "Export",
        all_promotion_replies: "Export all responses from the year group",
        all_promotion_replies_to_excel: "Export all responses from the promotion in Excel format",
        visit_date: "Export company visit dates",
        dashboard_excel: "Export dashboard in Excel format",
        questionnaires_pdf: "Export questionnaires",
      },
      roles: {
        alternate: "Work-study apprentice",
        educational_tutor: "Teaching tutor",
        company_tutor: "InseeCompany mentor",
        lea_manager: "Digital booklet supervisor",
      },
      got_to_questionnaire: "Access to the questionnaire",
      go_to_questionnaire: "Go to questionnaire",
    },
    gradeBookDashboard: {
      list: {
        title: "Notepad",
      },
      export_dashboard_excel: "Export notes in Excel format",
      caption: {
        danger: "Grade between the minimum grade and the lower average",
        success: "Grade between the upper average and the maximum grade",
      },
    },
    terminationPreventionDashboard: {
      list: {
        title: "Termination monitoring and prevention",
      },
      caption: "Termination monitoring and prevention, apprentices grouped by group",
      empty: "No apprentice matches your search.",
      filter_title: "Status",
      count: ({ plural, named }) => plural([`${named("count")} apprentice`, `${named("count")} apprentices`]),
      count_filtered: ({ named }) => `${named("visible")} of ${named("total")} apprentices`,
      weather: {
        title: ({ named }) => `Weather history of: ${named("apprentice")}`,
        empty: "No weather reading for this apprentice",
        author_deleted: "Deleted author",
        concern_reasons: "Reasons for concern",
      },
    },
    skillDashboard: {
      list: {
        title: "Skills dashboard",
      },
      export_dashboard_excel: "Export skills in Excel format",
      skill: {
        acquired: "Acquired",
        in_progress: "In progress",
        not_acquired: "Not acquired",
      },
    },
    export: {
      list: {
        title: "Exports",
      },
    },
    mail: {
      list: {
        title: "E-mail follow-up",
        empty: "Aucun mail n'a été envoyé pour le moment",
      },
      view: "Voir le contenu du mail",
      data: "Donnée du mail",
    },
    history: {
      list: {
        title: "Log-in history",
      },
    },
    assiduite: "Attendance management",
    subscriptions_dashboard: "Registrations dashboard",
    import: {
      modele: "File template download",
      defaultModele: "File template to download (default template)",
      triad_new_file:
        "Please note - a new template came online on 18/09/2023.\n" +
        "          Please download this updated version for use to populate your three-party groups.",
      triad_update:
        "Please note. Only the missing members of a three-party group will be updated. No existing user data (last name, first name or e-mail address) will be updated.",
      thanks: "Please do not modify and/or delete any of the columns in the template",
    },
    download_file_here: "Download the file HERE",
    session: {
      from: "From",
      to: "to",
      title: ({ plural }) => plural(["Period", "Periods"]),
    },
    user_never_connected: "This user has never logged in",
    welcome_mail_send: ({ named }) => `Welcome e-mail sent ${named("number")} times`,
    reset_password_mail_send: ({ named }) => `Reset e-mail sent ${named("number")} times`,
    see_last_mail_content: "View the content of the last e-mail sent",
    duplication: "Duplicated data",
    duplication_historic: "Duplication history",
    search_duplication: "Search for duplicates",
    see_duplication: "See all the information about this duplication",
    duplication_date: "Completion date",
    duplication_too_old: "You cannot restart a duplication that is more than 15 days old.",
    duplciation_status: {
      pending: "Pending",
      done: "Done",
      failed: "Failed",
    },
    duplication_status: {
      pending: "Pending",
      done: "Done",
      failed: "Failed",
    },
    reload_duplication: {
      title: "Relaunch this duplication",
      confirmation: "Are you sure you want to relaunch this duplication?",
    },
    details: "Details",
    status: "Status",
    statistic: {
      title: ({ plural }) => plural(["Statistics", "Statistics"]),
      shared_documents: "Incomplete three-party groups",
      calculation_in_progress: "Calculation of indicators in progress.",
      calculation_refresh: "Please wait a moment or refresh your page to update the calculation.",
    },
    driver_licence: {
      title: "Permis b",
      requests: "Demandes d'aide au permis B",
      list: "Liste des demandes d'aide au permis B",
      valid: "Valider la demande d'aide",
      valid_confirmation: "Êtes-vous sur de vouloir valider cette demande ?",
      export: "Exporter la liste des demandes d'aide",
      edit: "Modifier la demande de : ",
      overview: "Aperçu de la demande de : ",
      request_edit: {
        success: "Demande d'aide au permis B modifié avec succès",
      },
    },
    company: {
      title: ({ plural }) => plural(["Company", "Companies"]),
    },
    apprentice: {
      title: ({ plural }) => plural(["Apprentice", "Apprentices"]),
    },
    duplicated: {
      relaunch: "Relaunch",
      reference: "Reference",
      destination: "Destination",
      type: "Type of duplication",
      confirmation: "Are you sure you want to duplicate this data",
      action: {
        replace: "Replace",
        add: "Add",
        crush: "Crush",
        options: {
          title: "Options",
          add_to_current_year: "Add to current year",
          empty_training_course: "Only on empty promotions",
          add_to_due_date: "Add a year to the due dates",
          overwrite_current_year_only: "Overwrite current year only",
        },
      },
      questionnaire: {
        already_sign_not_affected: "Questionnaires already signed will not be affected",
        copy_even_if_already_existing: "Questionnaires will be copied even if they already exist",
        replace_questionnaire_with_same_name_questionnaire:
          "Questionnaires with the <strong>same name</strong> will be replaced.",
        replace_all: "Existing questionnaires will be deleted",
      },
      transition_report: {
        title: "Unprocessed promotions",
        destination: "Destination",
        questionnaire_count: ({ plural }) => plural(["questionnaire", "questionnaires"]),
        status_resolved: "Processed",
        status_blocked: "Blocked",
        status_skipped: "Skipped",
        status_would_create: "Promotion to create",
        step_same_training: "Same training",
        step_code_formation_acronym: "Training code + acronym",
        step_code_formation_name: "Training code + name",
        step_code_formation_year_number: "Training code + year",
      },
      training_course: {
        duplicated_data: "Duplicated data",
        add_data_if_empty: "Adds data if it doesn't exist",
        duplicate_choice: "You wish to duplicate",
        duplicate_from_reference: "Enables you to copy a standard booklet to a promotion package",
        duplicate_from_year: "Enables you to add a new year by duplicating the previous year's configuration",
      },
    },
    trainingPeriod: {
      title: ({ plural }) => plural(["Semester", "Semesters"]),
    },
    file: {
      title: ({ plural }) => plural(["File", "Files"]),
    },
    institution: {
      title: ({ plural }) => plural(["Institution", "Institutions"]),
    },
    component: {
      title: ({ plural }) => plural(["Component", "Components"]),
    },
    livretConfig: {
      title: "Booklet activation",
    },
  },
  add_session: "Add a period",
  edusign: {
    title: "Edusign",
    synchronize: {
      title: "Start synchronisation at Edusign",
      confirmation: "Are you sure you want to start synchronisation with Edusign?",
    },
    get_data: {
      title: "Recover absences and attendances",
      confirmation: "Are you sure you want to retrieve Edusign absences and attendances?",
    },
  },
  uniservice: {
    title: "Uniservice",
    get_data: {
      title: "Retrieve attendances",
      confirmation: "Are you sure you want to retrieve attendances from Uniservice?",
    },
    reset: {
      title: "Reset attendance and absences",
      confirmation: "Are you sure you want to delete attendances and absences from unvalidated schedules?",
    },
  },
};
